<div class="flow-shell">
  <header class="flow-header">
    <div class="flow-header__actions">
      <button
        *ngIf="pageHistory.length > 0 && !submitted && currentPage !== 'plans'"
        nz-button
        nzType="default"
        class="flow-header__back"
        (click)="goBack()"
      >
        <span nz-icon nzType="arrow-left"></span>
        Back
      </button>
      <button
        *ngIf="canShowCart"
        nz-button
        nzType="default"
        class="flow-header__cart"
        (click)="openCart()"
      >
        <span nz-icon nzType="shopping-cart"></span>
        Cart
      </button>
    </div>
    <div class="flow-header__meta">
      <h1>Dish Sales Flow</h1>
      <p>Current step: {{ currentStepLabel }}</p>
    </div>
  </header>

  <nz-progress class="flow-progress" nzStrokeLinecap="round" [nzPercent]="progressPercent"></nz-progress>

  <ul class="flow-steps" #flowStepsContainer>
    <li
      *ngFor="let step of orderedSteps"
      [class.is-complete]="isStepComplete(step)"
      [class.is-active]="isStepActive(step)"
      #flowStep
    >
      <span class="flow-steps__dot"></span>
      <span class="flow-steps__label">{{ stepLabels[step] }}</span>
    </li>
  </ul>

  <section class="flow-stage">
    <ng-container [ngSwitch]="currentPage">
      <ng-container *ngSwitchCase="'prequal'">
        <app-pre-qual (preQualResp)="handlePreQual($event)"></app-pre-qual>
      </ng-container>

      <ng-container *ngSwitchCase="'info'">
        <app-general-info [fullData]="fullData" (customerCreated)="handleCustomerCreated($event)"></app-general-info>
      </ng-container>

      <ng-container *ngSwitchCase="'qual'">
        <app-dish-qual [fullData]="fullData" (qualResponse)="handleQualResponse($event)"></app-dish-qual>
      </ng-container>

      <ng-container *ngSwitchCase="'plans'">
        <app-dish-plans [fullData]="fullData" (plans)="handleChosenPlans($event)"></app-dish-plans>
      </ng-container>

      <ng-container *ngSwitchCase="'equipment'">
        <app-dish-equipment [fullData]="fullData" (chosenEquipment)="handleEquipment($event)"></app-dish-equipment>
      </ng-container>

      <ng-container *ngSwitchCase="'install'">
        <app-dish-install [fullData]="fullData" (installData)="handleInstallData($event)"></app-dish-install>
      </ng-container>

      <ng-container *ngSwitchCase="'pfee'">
        <app-processing-fee [fullData]="fullData" (send)="handlePFeeData($event)"></app-processing-fee>
      </ng-container>

      <ng-container *ngSwitchCase="'payment'">
        <app-dish-payment [fullData]="fullData" (creditInfo)="handleCCData($event)"></app-dish-payment>
      </ng-container>

      <ng-container *ngSwitchCase="'review'">
        <app-dish-review [fullData]="fullData" (reviewInfo)="handleReview($event)"></app-dish-review>
      </ng-container>

      <ng-container *ngSwitchCase="'confirm'">
        <app-dish-confirmation [fullData]="fullData" (confirmed)="handleConfirm($event)"></app-dish-confirmation>
      </ng-container>
    </ng-container>
  </section>

  <nz-modal [(nzVisible)]="cartVisible" nzTitle="Dish Cart" [nzFooter]="null" (nzOnCancel)="closeCart()">
    <ng-container *nzModalContent>
      <div *ngIf="cartLoading" class="flow-cart__loading">
        <nz-spin nzSimple></nz-spin>
      </div>

      <div *ngIf="!cartLoading && cartPricing.length" class="flow-cart">
        <div class="flow-cart__category" *ngFor="let category of cartPricing">
          <div class="flow-cart__category-name">{{ category.CategoryName }}</div>
          <div class="flow-cart__product" *ngFor="let product of category?.Products || []">
            <span>{{ product.ProductName }}</span>
            <strong>{{ product.Price | currency }}</strong>
          </div>
        </div>
      </div>

      <p *ngIf="!cartLoading && !cartPricing.length" class="flow-cart__empty">
        Cart details are not available yet. Keep moving through the Dish flow and try again after the selections are saved.
      </p>
    </ng-container>
  </nz-modal>
</div>
